import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';

import { ShouldRender } from '../../../shared/basic/ShouldRender';

interface CardSliderType2Props {
  children?: ReactNode;
  isLeft?: boolean;
  lessPadding?: boolean;
}

const CardSliderType_2: FC<CardSliderType2Props> = ({
  children,
  isLeft = false,
  lessPadding = false,
}) => {
  const sliderRef = useRef<HTMLDivElement | null>(null);
  const [isAtLeftmost, setIsAtLeftmost] = useState(true);
  const [isAtRightmost, setIsAtRightmost] = useState(false);
  const [isOverFlowing, setIsOverFlowing] = useState(false);

  const scrollLeft = () => {
    sliderRef.current?.scrollBy({
      left: -300,
      behavior: 'smooth',
    });
  };

  const scrollRight = () => {
    sliderRef.current?.scrollBy({
      left: 300,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      if (sliderRef.current) {
        const isLeftmost = sliderRef.current.scrollLeft === 0;
        const isRightmost =
          sliderRef.current.scrollLeft + sliderRef.current.clientWidth ===
          sliderRef.current.scrollWidth;

        setIsAtLeftmost(isLeftmost);
        setIsAtRightmost(isRightmost);
      }
    };

    setIsOverFlowing(
      (sliderRef?.current?.scrollWidth || 0) >
        (sliderRef?.current?.scrollLeft || 0) +
          (sliderRef?.current?.clientWidth || 0),
    );
    sliderRef.current?.addEventListener('scroll', handleScroll);

    return () => {
      sliderRef.current?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className='flex relative'>
      <div className='w-full relative '>
        <div
          ref={sliderRef}
          className='flex gap-x-4  overflow-hidden '
          style={{ scrollBehavior: 'smooth', scrollbarWidth: 'none' }}
        >
          {children}
        </div>
        <ShouldRender check={isOverFlowing}>
          <div
            className={clsx(
              'flex md:pr-12  mt-2 ',
              isLeft ? ' justify-start pt-5' : 'justify-end pt-4 ',
              lessPadding && !isLeft ? 'md:pt-5' : 'md:pt-5',
            )}
          >
            <div className='flex items-center h-full justify-center px-4'>
              <button
                disabled={isAtLeftmost}
                onClick={scrollLeft}
                className='z-10 w-8 h-8 md:w-12 md:h-12 rounded-full disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-500  text-gray-800 flex cursor-pointer hover:bg-gray-50 justify-center items-center bg-white border border-gray-800'
              >
                <ChevronLeftIcon className=' w-4 h-4 md:w-7 md:h-7' />
              </button>
            </div>
            <div className='flex items-center h-full justify-center px-4'>
              <button
                disabled={isAtRightmost}
                onClick={scrollRight}
                className='z-10 w-8 h-8 md:w-12 md:h-12 rounded-full disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-500  text-gray-800 flex cursor-pointer hover:bg-gray-50 justify-center items-center bg-white border border-gray-800'
              >
                <ChevronRightIcon className=' w-4 h-4 md:w-7 md:h-7 ' />
              </button>
            </div>
          </div>
        </ShouldRender>
      </div>
    </div>
  );
};

export default CardSliderType_2;
